import eldorianTheme from "@/assets/themes/Eldorian_Forest_Realm.mp3";
import solarianTheme from "@/assets/themes/Empire_of_the_Sun.mp3";
import masonTheme from "@/assets/themes/Mountain_Stronghold_of_the_Masons.mp3";
import maritanTheme from "@/assets/themes/Coastal_Isles_of_the_Maritans.mp3";
import zephyrianTheme from "@/assets/themes/Plains_of_the_Nomads.mp3";
import races from "@/data/races.json";
import { useAuthStore } from "../store/auth";
import { useUiStore } from "../store/ui";

const raceAudioMap = {
  eldorians: eldorianTheme,
  Eldorians: eldorianTheme,
  solarians: solarianTheme,
  Solarians: solarianTheme,
  masons: masonTheme,
  Masons: masonTheme,
  maritans: maritanTheme,
  Maritans: maritanTheme,
  zephyrians: zephyrianTheme,
  Zephyrians: zephyrianTheme,
};

export function getRaceAudioPath(raceName) {
  return (
    raceAudioMap[raceName] ||
    raceAudioMap[String(raceName || "").toLowerCase()] ||
    null
  );
}

export function getRaceThemeLabel(raceName) {
  const slug = String(raceName || "").toLowerCase();
  const found = races.find(
    (race) => race.slug === slug || String(race.name || "").toLowerCase() === slug
  );
  return found?.name || raceName || "Unknown";
}

export function toggleRaceAmbiance() {
  const authStore = useAuthStore();
  const uiStore = useUiStore();
  if (!authStore.user?.race) return;

  const audioSrc = getRaceAudioPath(authStore.user.race);
  if (audioSrc) {
    uiStore.toggleAmbiance(audioSrc);
  }
}
